export function formatIncludeSold(includeSold: string | string[]) {
    if (includeSold === 'true') {
        return 'Include sold';
    }

    return '';
}
